import { NgModule } from '@angular/core';
import { ContentLayoutClientComponent } from './content-layout-client.component';
import { ClientMainBarComponent } from '../client-main-bar/client-main-bar.component';
import { ClientSideNavComponent } from '../client-side-nav/client-side-nav.component';
import { CommonModule } from '@angular/common';
import { ContentLayoutClientRoutingModule } from './content-layout-client-routing.module';
import { MaterialModule } from '@shared/material.module';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { DialogLoginModule } from '@shared/components/login/dialog/dialog.module';
import { FormLoginService } from '@shared/components/login/form-login/form-login.service';

    // tslint:disable-next-line: variable-name
@NgModule({
  declarations: [
    ContentLayoutClientComponent,
    ClientMainBarComponent,
    ClientSideNavComponent,
  ],
  imports: [
    FlexLayoutModule,
    CommonModule,
    MaterialModule,
    ContentLayoutClientRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DialogLoginModule,
    NgxMaskModule,
  ],
  exports:[
  ],
  entryComponents: [
  ],
  providers: [
    FormLoginService,
  ],
})
export class ContentLayoutClientModule { }
